module.exports = __webpack_public_path__ + "images/FUSA_icons/030-invoice-2.85dc679822be068c59f4370baa7b558d.svg";